import { is } from './is';

/**
 * A guest opens the dashboard's own candidate page at /s/:token/:submissionId, without an
 * account, after proving control of the address the grant was made for.
 *
 * The token is read once, at module load, before the router can navigate, and held here so
 * the existing candidate thunks can address the guest endpoints without a guest-specific
 * branch of their own: the API helpers swap the base path while the payloads, components
 * and reducers stay exactly as they are for a signed-in contact.
 */
const GUEST_PATH =
  /^\/s\/([A-Za-z0-9_-]{43})(?:\/([A-Za-z0-9_-]{1,100}))?(?:\/|$)/;

const token = window.location.pathname.match(GUEST_PATH)?.[1] ?? null;

export const getGuestShareToken = (): string | null => token;

export const isGuestShare = (): boolean => token !== null;

/** The submission the guest is looking at right now; read at call time because the guest moves between them. */
export const getGuestSubmissionId = (): string | null =>
  window.location.pathname.match(GUEST_PATH)?.[2] ?? null;

/**
 * Guest routes sit outside the `/api` prefix, so the URL has to be absolute to bypass the
 * axios baseURL. On localhost the API lives on its own origin.
 */
export const guestShareBase = (): string => {
  const origin = is.localhost
    ? process.env.REACT_APP_API_URL
    : window.location.origin;

  return `${origin}/s/${token}`;
};

export const guestListPath = (): string => `/s/${token}`;

export const guestSubmissionPath = (submissionId: string): string =>
  `${guestListPath()}/${submissionId}`;
